$(function() {
	var pessoa = 1;
	$("#site-nfs-index-search").click(function() {
		var btn = $(this);
		btn.button('loading');

		$.post('/cupom/search', { chave: $("#site-nfs-index-chave").val() }, function(r) {
			$("#site-nfs-index-content").html(r);
			btn.button('reset');
		})

	});

	$("#site-nfs-index-chave").keyup(function(e) {
		if (e.keyCode == 13) {
			$("#site-nfs-index-search").click();
		}
	});

	$("#site-nfs-index-chave").focus();

	$(document).off('click', "#site-nfs-index-content-print");
	$(document).on('click', '#site-nfs-index-content-print', function() {
		window.open("/cupom/print/chave/" + $(this).attr('chave'));
	});

	$(document).off('click', "#site-nfs-index-content-ident");
	$(document).on('click', '#site-nfs-index-content-ident', function() {
		var doc = $(this).attr('doc');
		var placa = $(this).attr('placa');

		if (placa && placa.length > 0) {
			$("#cupom-index-modal-placa").attr('disabled', 'disabled')
		} else {
			$("#cupom-index-modal-placa").removeAttr('disabled');
		}

		$("#cupom-index-modal-placa").val(placa);

		if (doc && doc.length > 0) {
			$("#cupom-index-modal-cpf").attr('disabled', 'disabled');
			$("#cupom-index-modal-cnpj").attr('disabled', 'disabled');
			if (doc.length == 18) {
				$("#cupom-index-modal-cnpj").val(doc);
				$("#cupom-index-modal-cnpj-btn").click();
			} else {
				$("#cupom-index-modal-cpf").val(doc);
				$("#cupom-index-modal-cpf-btn").click();
			}
		} else {
			$("#cupom-index-modal-cpf").removeAttr('disabled');
			$("#cupom-index-modal-cnpj").removeAttr('disabled');
		}

		$("#cupom-index-modal").modal('show');
	});

	$("#cupom-index-modal-cpf").mask('999.999.999-99');
	$("#cupom-index-modal-cnpj").mask('99.999.999/9999-99');

	$("#cupom-index-modal-cnpj-btn").click(function() {
		$("#cupom-index-modal-cpf-btn").removeClass('btn-primary').addClass('btn-default');
		$(this).removeClass('btn-default').addClass('btn-primary');
		$("#cupom-index-modal-cnpj-holder").show();
		$("#cupom-index-modal-cpf-holder").hide();
		pessoa = 2;
	});

	$("#cupom-index-modal-cpf-btn").click(function() {
		$("#cupom-index-modal-cnpj-btn").removeClass('btn-primary').addClass('btn-default');
		$(this).removeClass('btn-default').addClass('btn-primary');
		$("#cupom-index-modal-cpf-holder").show();
		$("#cupom-index-modal-cnpj-holder").hide();
		pessoa = 1;
	});

	$("#cupom-index-modal-cfm").click(function() {
		var data = {
			pessoa: pessoa,
			cpf: $("#cupom-index-modal-cpf").val(),
			cnpj: $("#cupom-index-modal-cnpj").val(),
			placa: $("#cupom-index-modal-placa").val(),
			chave: $("#site-nfs-index-content-ident").attr('chave')
		}
		var btn = $(this);
		btn.button('loading');
		$.post('/cupom/identificar', data, function(r) {
			btn.button('reset');
			$("#cupom-index-modal").modal('hide');
			if (r.response) {
				$("#site-nfs-index-chave").val(data.chave);
				$("#site-nfs-index-search").click();
			} else {
				$("#site-nfs-index-error").html(r.error).show();
			}
		}, 'json');
	});
	if ($("#site-nfs-index-chave").val().length > 0) {
		$("#site-nfs-index-search").click();
	}
});